import React from 'react';
import {Modal} from "antd";
import SpinLoader from "../../../components/SpinLoader";

const ResetAvailabilityModal = (props) => {

    const oneMonthFromNow = TB.moment().add(1, 'month').format('MMMM D, YYYY');
    return (
        <Modal
            title="Reset Availability Confirmation"
            open={props.isVisible}
            onCancel={() => props.onClose()}
            footer={(
                <div className="flex flex-row items-center gap-3 justify-end">
                    <button
                        key="cancel"
                        type="button"
                        className="btn btn-outline-dark"
                        onClick={() => props.onClose()}
                        disabled={props.isDisabled}
                    >
                        Cancel
                    </button>
                    <button
                        key="confirm"
                        type="button"
                        className="btn btn-dark"
                        disabled={props.isDisabled}
                        onClick={async () => {
                            await props.onUpdate();
                            return props.onClose()
                        }}
                    >
                        Confirm
                    </button>
                </div>
            )}
        >
            <SpinLoader isLoading={props.isDisabled}>
                <div>
                    <p className="mb-3">
                        Are you sure you would like to extend your availability?
                    </p>
                    <p className="text-sm font-semibold text-primary text-center">
                        I am available until <strong>{oneMonthFromNow}</strong>.
                    </p>
                </div>
            </SpinLoader>
        </Modal>
    )
};

export default ResetAvailabilityModal;